// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"aff64f4a","397":"8d61821c","411":"36d980c5","766":"198cf57c","886":"8fab9d85"}[chunkId] + ".chunk.css";
};